import { Box, Image, ResponsiveContext, ThemeContext } from "grommet";
import React, { useContext } from "react";
import { EnhancedBox, PositionAbsoluteBox, PositionRelativeBox } from "../../../../utils/styled";

const EmptyPageMessage = ({children, ...rest}) => {
    const size = useContext(ResponsiveContext);
    const theme = useContext(ThemeContext);
    return (
        <PositionRelativeBox
            background={{color: theme.dark ? 'foreground' : 'accent', opacity: 0.35}}
            round="small"
            fill="horizontal"
            pad={{ bottom: "xlarge", top: "large", horizontal: 'large'}}
            gap="small"
            margin={{vertical: 'large'}}
            direction="column"
        >
            <EnhancedBox styles="z-index: 1;" margin={{bottom: 'xlarge'}} {...rest}>
                {children}
            </EnhancedBox>
            {size !== "small" && (<PositionAbsoluteBox bottom="0" right="0" additionalStyle="z-index: 0;">
                <Box margin={{vertical: 'medium', horizontal: "small"}} opacity="0.5">
                    <Image src={`/illustrations/pricing${theme?.dark ? '_dark' : ''}.svg`} width="90%"/>
                </Box>
            </PositionAbsoluteBox>)}
        </PositionRelativeBox>
    );
};


export default EmptyPageMessage;